import {Component, Inject, OnInit} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {RouterModule} from '@angular/router';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-remind-castlabs-mfa',
    templateUrl: './remind-castlabs-mfa.component.html',
    styleUrls: ['./remind-castlabs-mfa.component.scss'],
  imports: [RouterModule]
})
export class RemindCastlabsMfaComponent implements OnInit {
  castlabs_idp_mfa_setup = environment.castlabs_idp_mfa_setup

  constructor(public dialogRef: DialogRef<any>) {
  }

  ngOnInit(): void {
  }

}
